import { useQuery } from '@tanstack/react-query';
import axios, { AxiosError, AxiosResponse } from 'axios';
import { AsyncPlanningResponseEntity, PlanningResponseEntity, PlanningResponseV5Entity } from 'src/entities/planningResponseEntity';

const requestPath = (request: AsyncPlanningResponseEntity) => {
  let query = '';
  if (request.session_id) {
    query = `session_id=${request.session_id}`;
  } else if (request.respect_recent_id) {
    query = `respect_recent_id=${request.respect_recent_id}`;
  } else if (request.scenario_planning_id) {
    query = `scenario_planning_id=${request.scenario_planning_id}`;
  }
  return `/api/v3/plannings/result?${query}`;
};

const getAll = (request: AsyncPlanningResponseEntity) => async () => {
  const response: AxiosResponse<PlanningResponseEntity> = await axios.get(requestPath(request));

  return response.data;
};

export const useQueryPlanningsResults = (request: AsyncPlanningResponseEntity) => useQuery<PlanningResponseEntity, AxiosError<{ message: string }>>({
  queryKey: ['useQueryPlanningsResults', { sessionId: request?.session_id, respectRecentId: request?.respect_recent_id, scenarioPlanningId: request?.scenario_planning_id }],
  queryFn: getAll(request),
  refetchInterval: 1 * 1000,
  enabled: request != null,
});

const requestPathV5 = (request: AsyncPlanningResponseEntity) => {
  let query = '';
  if (request.session_id) {
    query = `session_id=${request.session_id}`;
  } else if (request.respect_recent_id) {
    query = `respect_recent_id=${request.respect_recent_id}`;
  } else if (request.scenario_planning_id) {
    query = `scenario_planning_id=${request.scenario_planning_id}`;
  }
  return `/api/v5/plannings/result?${query}`;
};

const getAllV5 = (request: AsyncPlanningResponseEntity) => async () => {
  const response: AxiosResponse<PlanningResponseV5Entity> = await axios.get(requestPathV5(request));

  return response.data;
};

export const useQueryPlanningsResultsV5 = (request: AsyncPlanningResponseEntity) => useQuery<PlanningResponseV5Entity, AxiosError<{ message: string }>>({
  queryKey: ['useQueryPlanningsResultsV5', { sessionId: request?.session_id, respectRecentId: request?.respect_recent_id, scenarioPlanningId: request?.scenario_planning_id }],
  queryFn: getAllV5(request),
  refetchInterval: 1 * 1000,
  enabled: request != null,
});
